export default "<ng-container *ngIf=\"platform\">\r\n    <router-outlet></router-outlet>\r\n</ng-container>\r\n<notifier-container></notifier-container>";